"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var actions = _interopRequireWildcard(require("./apiActions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Endpoint = /*#__PURE__*/function () {
  function Endpoint(_ref) {
    var endpoint = _ref.endpoint,
        _ref$version = _ref.version,
        version = _ref$version === void 0 ? "" : _ref$version,
        _ref$method = _ref.method,
        method = _ref$method === void 0 ? "GET" : _ref$method,
        _ref$transformRequest = _ref.transformRequest,
        transformRequest = _ref$transformRequest === void 0 ? function (body) {
      return body;
    } : _ref$transformRequest,
        _ref$transformRespons = _ref.transformResponse,
        transformResponse = _ref$transformRespons === void 0 ? function (data) {
      return data;
    } : _ref$transformRespons,
        _ref$prepareRequestOp = _ref.prepareRequestOptions,
        prepareRequestOptions = _ref$prepareRequestOp === void 0 ? null : _ref$prepareRequestOp,
        _ref$includeToken = _ref.includeToken,
        includeToken = _ref$includeToken === void 0 ? false : _ref$includeToken,
        _ref$reducer = _ref.reducer,
        reducer = _ref$reducer === void 0 ? "api" : _ref$reducer,
        _ref$credentials = _ref.credentials,
        credentials = _ref$credentials === void 0 ? "omit" : _ref$credentials;
    (0, _classCallCheck2.default)(this, Endpoint);
    this.name = "";
    this.version = version;
    this.endpoint = endpoint;
    this.method = method;
    this.transformRequest = transformRequest;
    this.transformResponse = transformResponse;
    this.includeToken = includeToken;
    this.reducer = reducer;
    this.prepareRequestOptions = prepareRequestOptions;
    this.api = null;
    this.requestActionCreator = this.requestActionCreator.bind(this);
    this.defaultCredentials = credentials;
  }

  (0, _createClass2.default)(Endpoint, [{
    key: "initialize",
    value: function initialize(api, name) {
      this.api = api;
      this.name = name;

      if (this.prepareRequestOptions === null) {
        this.prepareRequestOptions = api.prepareRequestOptions;
      }
    }
  }, {
    key: "requestActionCreator",
    value: function requestActionCreator() {
      var requestOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var credentials = requestOptions.credentials,
          otherOptions = (0, _objectWithoutProperties2.default)(requestOptions, ["credentials"]);
      return _objectSpread({
        type: actions.API_CALL_REQUESTED,
        apiName: this.api.apiName,
        apiReference: this.api.apiReference,
        apiSettings: this.api.apiSettings,
        endpointName: this.name,
        credentials: credentials || this.defaultCredentials
      }, otherOptions);
    }
  }, {
    key: "bindDispatch",
    value: function bindDispatch(dispatch) {
      var _this = this;

      return function (requestOptions) {
        return dispatch(_this.requestActionCreator(requestOptions));
      };
    }
  }, {
    key: "call",
    value: function call() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var overrideOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _this$transformReques = this.transformRequest(options),
          body = _this$transformReques.body,
          urlArgs = _this$transformReques.urlArgs,
          searchParams = _this$transformReques.searchParams,
          credentials = _this$transformReques.credentials;

      var token = this.includeToken ? this.api.token : null;
      var version = this.version || this.api.version;

      var endpoint = function () {
        if (version) {
          return "".concat(version, "/").concat(_this2.endpoint);
        }

        return _this2.endpoint;
      }();

      var data = this.api.sendRequest(endpoint, {
        method: this.method,
        body,
        token,
        urlArgs,
        searchParams,
        credentials: credentials || overrideOptions.credentials || this.defaultCredentials
      }, this, overrideOptions);
      return data;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.name;
    }
  }]);
  return Endpoint;
}();

var _default = Endpoint;
exports.default = _default;